import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isGoogleAuthenticated, setIsAuthenticated] = useState(() => {
    const storedAuth = localStorage.getItem('isGoogleAuthenticated');
    return storedAuth === 'true';
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedAuth = localStorage.getItem('isGoogleAuthenticated');
    setIsAuthenticated(storedAuth === 'true');
    setLoading(false);
  }, []);

  const googlelogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isGoogleAuthenticated', 'true');
  };

  const googlelogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('isGoogleAuthenticated');
  };

  return (
    <AuthContext.Provider value={{ isGoogleAuthenticated, googlelogin, googlelogout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
